module.exports = __webpack_public_path__ + "biologic-full.png";